import type { MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType } from './messagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfoAllOfTwo = {
  content?: string;
  type?: MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageBasicInfoAllOfTwoType;
};
